// Components
import "./components/SizeConverter";
import './components/HeroBanner';
import './components/TrustpilotWidget';
import './components/StoreAccordion';
import './components/VariantNotice';
import './components/ReadMore';
import './components/VariantUpsell';

// Modules
import FooterAccordion from "./modules/FooterAccordions";
import PreorderForm from "./modules/PreOrderForm";

new FooterAccordion();
new PreorderForm();
